import { DateIRLToErache, formatEventDateLocal } from "../../utils/dateConverters";

/**
 * @param {Date} date
 * @param {'irl'|'erache'} dateMode
 */
export function formatEventDateLine(date, dateMode) {
  if (!date) return "";
  return dateMode === "irl" ? formatEventDateLocal(date) : DateIRLToErache(date);
}

/**
 * @param {Date} start
 * @param {Date|null|undefined} end
 * @param {'irl'|'erache'} dateMode
 */
export function formatPeriodRangeLine(start, end, dateMode) {
  if (!start) return "";
  const a = formatEventDateLine(start, dateMode);
  if (!end) return `${a} — …`;
  const b = formatEventDateLine(end, dateMode);
  return `${a} — ${b}`;
}
